module.exports = __webpack_public_path__ + "static/media/paiming1.09c07962.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_130/image/paiming1.png
// module id = 380
// module chunks = 0